export default __webpack_public_path__ + "static/media/aboutus31.09d764ad.webp";